import React from 'react';
const Sorters = ({setSorters}) => {

    const handleChanges = (e) => {
        if(e.target.value === "0"){
            setSorters({"sorter": "name", "order": "asc"})
        } else if(e.target.value === "1"){
            setSorters({"sorter": "name", "order": "desc"})
        } else if(e.target.value === "2"){
            setSorters({"sorter": "date", "order": "desc"})
        } else if(e.target.value === "3"){
            setSorters({"sorter": "date", "order": "asc"})
        }
    }

    return (
        <select defaultValue={"-1"} onChange={(e)=>handleChanges(e)} className="w-full border-0 font-base shadow-xl rounded-xl">
            <option className='font-light' disabled value={"-1"}>Ordenar por</option>
            <option className='font-light' value="0">A-Z</option>
            <option className='font-light' value="1">Z-A</option>
            <option className='font-light' value="2">Mas recientes</option>
            <option className='font-light' value="3">Mas antiguos</option>
        </select>
    );
}

export default Sorters;